<template>
<div>

<!-- Modal -->

  <div class="modal modal-mask" id="stockHistory" style="display: block">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">

    <div class="modal-content">
      <div class="modal-header bg-info">
        <h4 style="color:white" class="modal-title" id="staticBackdropLabel">PREZZO DI ACQUISTO E SCONTO</h4>
        
      </div>
      <div class="modal-body">
        
        <div class="table-wrapper-scroll-y my-custom-scrollbar">  
        <table class="table table-bordered table-sm">
        <thead>
            <tr>
            <th scope="col">DOCUMENTO</th>     
            <th scope="col">NUMERO</th>                             
            <th scope="col">DATA</th>     
            <th scope="col">MISURA</th>
            <th scope="col">PREZZO DI ACQUISTO</th>
            <th scope="col">SCONTO</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item,index) in items" :key="index">
                <td>{{item.doc}}</td>
                <td>{{item.number}}</td>
                <td>{{item.date}}</td>
                
                <td>{{item.size}}</td>
                <td class="text-right"><strong>{{fmt1(item.price)}}</strong></td>
                <td class="text-right"><strong>{{item.discount}}</strong> %</td>
            </tr>
        </tbody>
        </table>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button"  @click="$emit('close')" class="btn btn-primary" data-dismiss="modal">CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>

</div>
</template>

<script>



import fmt  from '@/components/mixins/fmt.js'
import api from '@/api'
  export default {
  mixins:[fmt],  
  props : ['productId','stockMovementId'],

     
    data () {
      return {
        
          items : []
        
      
      }
    },
    

    created () 
      {
      
        this.getData()
      },
    methods: 
    {
      async getData()
      {
        const data = {'productId' : this.productId,'stockMovementId':this.stockMovementId}  
        const sp   = {'sp':'spProductMovementCostPrice'}
        const json = Object.assign(data, sp)  
        


        await api.post(json).then(res => {
          if(res.status==200)
            {
             this.items = res.data.recordsets[0]
             

                 
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });


        

  
      },
      
      

      
      

    }
  }
</script>
<style scoped>



  h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}


.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.my-custom-scrollbar {
    position  : relative;
    height    : 250px;
    overflow  : auto;
    }
.table-wrapper-scroll-y {
    display   : block;
  }
</style>
